import LocalesMapper from './LocalesMapper';

/**
 * All available Locale @braincube
 * @type {any[]}
 */
const availableLocales = Object.values(LocalesMapper.LOCALES);

/**
 * Find the Braincube front standard locale given the external locale provided
 * If full given locale is not found we try to retrieve short version (2 chars) one using first part.
 * If nothing relevant was found it fallback to english.
 *
 * @param {string} externalLocale - locale string from outside
 * @returns {string} the Braincube front format locale
 */
function getLocaleKey(externalLocale) {
  if (externalLocale === 'pt-BR') {
    return LocalesMapper.LOCALES.PT_BR;
  }
  return availableLocales.find(locale => locale === externalLocale) || availableLocales.find(locale => locale === externalLocale.split(/-/, 1)[0]) || LocalesMapper.LOCALES.EN;
}
export default getLocaleKey;